import recentlyViewedHelper from 'utils/recentlyViewedHelper';
import { AppDispatch, Store } from 'store';
import getCategoryId from 'store/category/selector/getCategoryId';
import getDesignedProduct from 'store/product/selector/getDesignedProduct';
import getProductPreviews from 'store/product/selector/getProductPreviews';
import { RECENTLY_VIEWED_TYPES } from 'constants/app';
import getProductId from '../selector/getProductId';
import getProductItem from '../selector/getProductItem';
import { ProductItemPreviewProps } from '../types';

const storeRecentlyViewedOperation = (designId: string) => async (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();
  const categoryId = getCategoryId(store) || 1;
  const productItem = getProductItem(store);

  const originalPreviews = getProductPreviews(store);
  const product = getDesignedProduct(store);
  const designName = product?.content.designName;
  const productId = getProductId(store);

  const { storeRecentlyViewed } = recentlyViewedHelper();

  const uniqueProductId = designId + String(productId);

  if (productItem && RECENTLY_VIEWED_TYPES.includes(productItem?.product.productTypeId)) {
    const item: ProductItemPreviewProps = {
      showPrice: true,
      categoryId,
      productId,
      productUrl: window.location.pathname,
      productThumbnail: originalPreviews[0],
      productName: designName || '',
      timestamp: new Date().getTime(),
      uniqueProductId,
    };
    storeRecentlyViewed(item);
  }
};

export default storeRecentlyViewedOperation;
